
import { useState, useEffect, useContext } from "react";
import { useLocation } from "react-router-dom";
import { Layout, Drawer, Affix } from "antd";
import Sidenav from "./Sidenav";
import Header from "./Header";
import { AppStateContext } from "../../context/AppContext";
import ErrorBoundary from '../ErrorBoundary';
import LogoAsset from '../../assets/images/logo-for-logins.png';

const { Header: AntHeader, Content, Sider } = Layout;


// FallbackHeader — the absolute minimum top nav to render when the full
// Header component crashes. No AuthContext, no antd, no state — just a logo
// and a "Sign out" link that wipes localStorage and redirects to /. Studios
// keep visible nav + a way out even if the fancy header breaks.
function FallbackHeader() {
  // DARK_FALLBACK_HEADER — matches the dashboard dark theme. Shown only when
  // the full Header crashes. Reads studio name from whatever localStorage
  // shape the app has been using so it looks personalised for the studio.
  let studioName = "";
  try {
    const raw = localStorage.getItem("userData") || localStorage.getItem("user") || localStorage.getItem("userProfile") || "{}";
    const u = JSON.parse(raw);
    studioName = (u.franchise_id || u.gym_name || u.name || "").toString().toUpperCase();
  } catch (_) {}

  const signOut = () => {
    try {
      ["accessToken","refreshToken","token","userData","user","userProfile"].forEach(k => localStorage.removeItem(k));
    } catch (_) {}
    window.location.href = "/";
  };

  return (
    <div style={{
      display: "flex", alignItems: "center", justifyContent: "space-between",
      width: "100%", height: "100%", padding: "0 24px",
      background: "transparent", color: "#fff",
    }}>
      <div style={{ width: 120 }} />
      <img src={LogoAsset} alt="FusionHub"
        style={{ height: 40, objectFit: "contain", filter: "brightness(1.4)" }} />
      <div style={{
        display: "flex", alignItems: "center", gap: 10,
        padding: "8px 14px", background: "rgba(255,255,255,0.05)",
        border: "1px solid rgba(255,255,255,0.1)", borderRadius: 10,
      }}>
        <span style={{ fontSize: 13, fontWeight: 500, color: "#fff", letterSpacing: "0.02em" }}>
          {studioName || "STUDIO"}
        </span>
        <button
          onClick={signOut}
          title="Sign out"
          style={{
            background: "transparent", border: "none", cursor: "pointer",
            color: "#a0a0a0", fontSize: 12, fontWeight: 500, padding: "2px 6px",
          }}>
          Sign out
        </button>
      </div>
    </div>
  );
}

function Main({ children }) {
  const [visible, setVisible] = useState(false);
  const [placement, setPlacement] = useState("right");
  const [sidenavColor, setSidenavColor] = useState("#1890ff");
  const [sidenavType, setSidenavType] = useState("transparent");
  const [fixed, setFixed] = useState(false);

  const openDrawer = () => setVisible(!visible);
  const [toggle, setToggle] = useState(false);
  const handleSidenavType = (type) => setSidenavType(type);
  const handleSidenavColor = (color) => setSidenavColor(color);
  const handleFixedNavbar = (type) => setFixed(type);

  let { pathname } = useLocation();
  pathname = pathname.replace("/", "");

  const { pageHeading } = useContext(AppStateContext);

  // Hide header for stream links
  const shouldHideHeader = pathname === "stream-section";

  useEffect(() => {
    if (pathname === "rtl") {
      setPlacement("left");
    } else {
      setPlacement("right");
    }
    setVisible(false);
  }, [pathname]);

  return (
    <Layout
      className={`layout-dashboard ${
        pathname === "profile" ? "layout-profile" : ""
      } ${pathname === "rtl" ? "layout-dashboard-rtl" : ""}`}
    >
      {/* <Drawer
        title={false}
        placement={placement === "right" ? "left" : "right"}
        closable={false}
        onClose={() => setVisible(false)}
        open={visible}
        key={placement === "right" ? "left" : "right"}
        width={250}
        className={`drawer-sidebar ${
          pathname === "rtl" ? "drawer-sidebar-rtl" : ""
        } `}
      >
        <Layout
          className={`layout-dashboard ${
            pathname === "rtl" ? "layout-dashboard-rtl" : ""
          }`}
        >
          <Sider
            trigger={null}
            width={250}
            theme="light"
            className={`sider-primary ant-layout-sider-primary ${
              sidenavType === "#fff" ? "active-route" : ""
            }`}
            style={{ background: sidenavType }}
          >
            <Sidenav color={sidenavColor} />
          </Sider>
        </Layout>
      </Drawer>
      <Sider
        breakpoint="lg"
        collapsedWidth="0"
        onCollapse={(collapsed, type) => {}}
        trigger={null}
        width={250}
        theme="dark"
        className={`sider-primary ant-layout-sider-primary ${
          sidenavType === "#fff" ? "active-route" : ""
        }${toggle ? "visible-class" : ""}`}
        style={{ background: sidenavType }}
      >
        <Sidenav color={sidenavColor} />
      </Sider> */}
      <Layout>
        {!shouldHideHeader && (
          fixed ? (
            <Affix>
              <AntHeader className={`${fixed ? "ant-header-fixed" : ""}`}>
                <ErrorBoundary silent fallback={<FallbackHeader />}>
                  <Header
                    onPress={openDrawer}
                    name={pageHeading}
                    setToggle={() => setToggle((prev) => !prev)}
                    subName={pageHeading}
                    handleSidenavColor={handleSidenavColor}
                    handleSidenavType={handleSidenavType}
                    handleFixedNavbar={handleFixedNavbar}
                    totalDuration={window.currentDayTotalDuration || 0}
                  />
                </ErrorBoundary>
              </AntHeader>
            </Affix>
          ) : (
            <AntHeader className={`${fixed ? "ant-header-fixed" : ""}`}>
              <ErrorBoundary silent fallback={<FallbackHeader />}>
                <Header
                  onPress={openDrawer}
                  name={pageHeading}
                  subName={pageHeading}
                  setToggle={() => setToggle((prev) => !prev)}
                  handleSidenavColor={handleSidenavColor}
                  handleSidenavType={handleSidenavType}
                  handleFixedNavbar={handleFixedNavbar}
                  totalDuration={window.currentDayTotalDuration || 0}
                />
              </ErrorBoundary>
            </AntHeader>
          )
        )}

        <Content className="content-ant">{children}</Content>
      </Layout>
    </Layout>
  );
}

export default Main;
